import gql from 'graphql-tag';

const zendeskJwtGql = gql`
  query {
    zen: properties {
      user {
        jwt: zendeskjwt {
          success
          token: access_token
          scope
          expires_in
          token_type
          message
        }
      }
    }
  }
`;

export default zendeskJwtGql;
